import "./Structural.module.css";
import Header from "@/reusable_sections/Header";
import EstructuralesHeroBanner from "./sections/EstructuralesHeroBanner";
import StructuralProductsDescription from "./sections/StructuralProductsDescription";
import StructuralProductsGrid from "./sections/StructuralProductsGrid";
import Footer from "@/reusable_sections/Footer";
export default function StructuralPage() {
  return <div>
      <Header />
      <EstructuralesHeroBanner />
      <StructuralProductsDescription />
      <StructuralProductsGrid />
      <Footer />
    </div>;
}